<template>
	<v-expansion-panel
		v-for="page in groupedPage"
		:key="page"
	>
		<v-expansion-panel-title>/ {{ page.name }}</v-expansion-panel-title>
		<v-expansion-panel-text>
			<v-data-table
				:items="page.templates"
				:headers="tableHeaders"
				hide-table-footer
			>
				<template #item.title="{ item }">
					<a :href="`/bo/pages/edit?id=${item.id}`">{{ item.title }}</a>
				</template>
				<template #item.language="{ item }">
					<img
						:src="`/images/flags/${item.language}.svg`"
						width="24"
						height="24"
					>
				</template>
				<template #item.published="{ item }">
					<img
						v-if="item.published"
						src="/bo/images/icons/bullet_green.png"
					>
					<img
						v-else
						src="/bo/images/icons/bullet_red.png"
					>
				</template>
				<template #item.actions="{ item }">
					<confirm-delete-button
						:id="item.id"
						v-can="'page.delete'"
						url="/api/v0/domainpages"
						:text="$gettext('Are you sure you want to delete this page?')"
					/>
				</template>
				<template #bottom />
			</v-data-table>
			<div v-if="page.children">
				<v-expansion-panels multiple>
					<pages-overview-expansion-panel :grouped-page="page.children" />
				</v-expansion-panels>
			</div>
		</v-expansion-panel-text>
	</v-expansion-panel>
</template>

<script>

export default {
	name: 'PagesOverviewExpansionPanel',

	props: {
		groupedPage: {
			type: Object,
			required: true
		}
	},

	computed: {
		tableHeaders () {
			return [
				{
					title: 'Title',
					value: 'title',
					sortable: false,
				},
				{
					title: 'Language',
					value: 'language',
					sortable: false,
				},
				{
					title: 'Published',
					value: 'published',
					sortable: false,
				},
				{
					title: 'Priority',
					value: 'priority',
					sortable: false,
				},
				{
					title: 'Actions',
					value: 'actions',
					sortable: false,
				},
			];
		}
	},
};
</script>
